import { studentFragments } from "Teacher/routes/Projects/modules/ProjectFragments";
import { gql } from "lib/apolloClient";
import { userNameFragment } from "modules/CommonFragments";

export const projectInfoFragment = gql`
  fragment projectInfo on Project {
    id
    status
    reportStatus
    completedDeadlines {
      completedAt
      deadline {
        id
        deadlineDate
      }
    }
    fields(filters: $projectFieldFilters) {
      id
      uid
      pseudoFieldUid
      isComplete
      attachments {
        id
        type
      }
      value
      resolvedMinimalTree {
        id
        type
        ... on ResolvedFieldPlannerElementSet {
          id
          type
          ... on ResolvedFieldPlannerElementSet {
            id
            type
            nodes {
              id
              label
              type
            }
          }
        }
      }
    }
    students {
      ...studentInfo
    }
    supervisors {
      ...userNameFields
      profileImage
    }
    cascadeUpdateAt
    cascadeUpdateBy {
      ...userNameFields
    }
    createdAt
    createdBy {
      ...userNameFields
    }
    updatedAt
    updatedBy {
      ...userNameFields
    }
  }
  ${studentFragments.studentInfoFragmentV2}
  ${userNameFragment}
`;
